<template>
  <div class="aftermarket">
    <Header pageTitle="退换/售后" />
    <div class="aftermarketList">
      <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="ordersList">
        <div class="list_2" v-for="orderInfo in aftermarketListData" :key="orderInfo.id">
          <div class="list-items_1-0">
            <div @click="goAftermarketInfo(orderInfo)">
              <div class="text-wrapper_5-0">
                <span class="text_8-0">{{ orderInfo.shopName }}</span>
                <!-- 售后类型 -->
                <span class="text_9-0">{{ orderInfo.type | saleTypeFilters }}</span>
              </div>
              <div class="block_3-0">
                <div class="image-text_2-0">
                  <div class="box_4-0">
                    <img :src="orderInfo.albumPics
                      ? $global.imgUrl +
                      orderInfo.albumPics.split(',')[0]
                      : require('@/assets/img/mobile-img/zz_default.png')
                    " alt="" />
                  </div>
                  <div class="text-group_2-0">
                    <p class="text_10-0">
                      {{ orderInfo.goodsName }}
                    </p>
                    <p class="text_11-0">
                      <span>{{ orderInfo.specificationsValueOne }}</span>
                      <span>{{ orderInfo.specificationsValueTwo }}</span>
                    </p>
                    <p class="text_11-0">
                      数量：{{ orderInfo.returnCount }}
                    </p>
                  </div>
                </div>
              </div>
              <van-button class="text-wrapper_3-0" @click="goAftermarketInfo(orderInfo)">
                <span>
                  <span>{{ orderInfo.latestProgressDesc }}</span>
                </span>
                <span>
                  <van-icon name="arrow" />
                </span>
              </van-button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import Header from "@/views/mobileView/components/header/index.vue";
export default {
  components: {
    Header
  },
  data() {
    return {
      tokens: "",
      aftermarketListData: [],
      loading: false,
      finished: false,
      aftermarketParams: {
        // 分页 默认20条
        pageNo: 0,
        pageSize: 20,
      }
    }
  },
  created() {
    this.tokens = sessionStorage.getItem("token");
    this.ordersList();
  },
  filters: {
    saleTypeFilters(value) {
      switch (value) {
        case 1:
          return '换货';
        case 2:
          return '退货退款';
        case 3:
          return '仅退款';
      }
    },
  },

  methods: {
    async ordersList() {
      this.loading = true;
      this.aftermarketParams.pageNo += 1;
      var res = await this.$apis.afterSalesOrder.afterSaleList(this.aftermarketParams);
      if (res.resultCode == 200) {
        this.aftermarketListData.push(...res.data.list);
        // 加载状态结束
        this.finished = res.data.list.length < 20;
        this.loading = false;
      } else {
        this.$toast(res.resultDesc);
      }
    },
    goAftermarketInfo(goAftermarketInfo) {
      if (this.tokens) {
        this.$router.push({
          path: "/aftermarketInfo",
          query: {
            id: goAftermarketInfo.id
          },
        });
      } else {
        this.$router.push("logins");
      }
    }
  }
}
</script>
<style lang="scss">
html,
body {
  height: 100%;
  background: #f5f5f5;
}

.aftermarket {
  width: 100%;
  height: 100%;
  padding-top: calc(constant(safe-area-inset-top) + 44px) !important;
  padding-top: calc(env(safe-area-inset-top) + 44px) !important;

  .aftermarketList {
    width: 100%;

    .list_2 {
      margin: 0 auto;
      margin-top: 12px;
      width: 94%;
      background: #fff;
      padding-bottom: 12px;
      border-radius: 8px;

      .list-items_1-0 {
        margin: 0 auto;
        width: 94%;
        background: #fff;

        .text-wrapper_5-0 {
          width: 94%;
          height: 45px;
          line-height: 45px;

          .text_8-0 {
            float: left;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .text_9-0 {
            float: right;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #B2B2B2;
          }
        }

        .block_3-0 {
          height: 90px;

          .image-text_2-0 {
            float: left;

            .box_4-0 {
              width: 80px;
              height: 80px;
              float: left;
              border: 1px solid transparent;
              border: none;
              border-radius: 6px;
              overflow: hidden;

              img {
                width: 80px;
                height: 80px;
                float: left;
              }
            }

            .text-group_2-0 {
              float: left;
              width: 204px;
              margin-left: 10px;

              .text_10-0 {
                font-size: 15px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }

              .text_11-0 {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                margin-top: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }

          .text_12-0 {
            float: right;
            margin: 31px auto;
          }
        }

        .text-wrapper_3-0 {
          width: 100%;
          height: 40px;
          line-height: 40px;
          display: flex;
          padding: 0 10px 0 20px;
          background: #f5f5f5;
          border: 1px solid transparent;
          border-radius: 6px;
          color: #333333;

          .van-button__content {
            width: 100%;

            .van-button__text {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 400;
              color: #333333;

              .title {
                font-weight: 500;
                margin-right: 23px;
              }
            }
          }


        }


      }
    }
  }
}
</style>